import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const tipoIntegracao_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TipoIntegracao/GetList")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default tipoIntegracao_api;
